module.exports = __webpack_public_path__ + "assets/img/img-map-tokyo-sp.7ff554d3.svg";